import { Slider } from 'antd'
import { usePointCloudContext } from 'features/pointClouds'
import { PointColorType } from 'gecko-potree-core'
import {
  SliderContainer,
  SliderLabel,
  SliderRow,
  SliderValue,
} from 'pages/pointClouds/components/hud/controlPanel/ControlPanel.styles'
import { EDLSettings } from 'pages/pointClouds/components/hud/controlPanel/EDLSettings'
import { HSVControls } from 'pages/pointClouds/components/hud/controlPanel/HSVControls'
import React from 'react'

export const ColorSliders: React.FC = () => {
  const { enableEdl, colorMode, gamma, setGamma } = usePointCloudContext()

  return (
    <>
      <SliderRow>
        <SliderLabel>
          Gamma: <SliderValue>{gamma.toFixed(2)}</SliderValue>
        </SliderLabel>
        <SliderContainer>
          <Slider
            value={gamma}
            min={0}
            max={6}
            step={0.01}
            onChange={(value) => setGamma(value)}
          />
        </SliderContainer>
      </SliderRow>

      {colorMode === PointColorType.FILTERED_HUE && <HSVControls />}
      {enableEdl && <EDLSettings />}
    </>
  )
}
